import React from 'react';
import css from './CustomExtendedDataField.module.css';
import { brandModels } from '../../config/configExtras';
import FieldCheckboxGroup from '../FieldCheckboxGroup/FieldCheckboxGroup';
import classNames from 'classnames';
import { isArrayLength } from '../../util/genericHelpers';

const BrandModels = ({ formId, isEditListingFlds, enumOptions, pub_brandname, values }) => {
  if (!isArrayLength(pub_brandname) || !isArrayLength(enumOptions)) {
    return null;
  }
  const selectedBrands = pub_brandname.map(
    brandOption => enumOptions.find(opt => opt.option === brandOption)?.label || brandOption
  );
  const allModels = selectedBrands
    .flatMap(
      brand => brandModels.find(b => b.brand.toLowerCase() === brand.toLowerCase())?.models || []
    )
    .filter((model, index, self) => self.indexOf(model) === index); // Remove duplicates
  const modelOptions = allModels.map(model => ({ key: model.toLowerCase(), label: model }));

  return isArrayLength(modelOptions) ? (
    <FieldCheckboxGroup
      className={classNames(css.customField, { [css.editListingFlds]: isEditListingFlds })}
      id={formId ? `${formId}.pub_model` : 'pub_model'}
      name="pub_model"
      label="Models"
      options={modelOptions}
    />
  ) : null;
};

export default BrandModels;
